import { render, staticRenderFns } from "./ProductRegion.vue?vue&type=template&id=3c6b5bee&scoped=true&"
import script from "./ProductRegion.vue?vue&type=script&lang=js&"
export * from "./ProductRegion.vue?vue&type=script&lang=js&"
import style0 from "./ProductRegion.vue?vue&type=style&index=0&id=3c6b5bee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6b5bee",
  null
  
)

export default component.exports